export class Cartridge {
  id: number
  diameterMinimum: number
  name: string
  
  constructor(id: number, diameterMinimum?: number, name?: string) {
    this.id = id
    this.diameterMinimum = diameterMinimum ?? 0
    this.name = name ?? ''
  }
}
